// @flow
import storage, { keys } from 'lib/storage';
import * as dbTracker from './dbTracker';
import * as clarityTracker from './clarityTracker';
import * as gtmTracker from './gtmTracker';
import { TRACKING_EVENTS } from './events';

export { TRACKING_EVENTS };

type User = {
  id: string,
  [key: string]: any,
};

type EventProperties = {
  productId?: string,
  productSlug?: string,
  productTitle?: string,
  productPriceId?: string,
  brand?: string,
  supplierUsername?: string,
  quantity?: number,
  [key: string]: any,
};

const getUser = (): ?User => {
  return storage.get(keys.user);
};

export const identifyUser = (user: User): void => {
  gtmTracker.setUser(user);
  clarityTracker.identify(user);
};

export const track = async (
  eventName: string,
  properties: EventProperties = {},
): Promise<void> => {
  gtmTracker.push(eventName, properties);
  clarityTracker.trackEvent(eventName, properties);

  const user = getUser();
  if (!user) return;

  setTimeout(() => {
    dbTracker.send(eventName, properties);
  }, 200);
};

export const trackPageView = async (
  location?: { pathname: string, search: string },
): Promise<void> => {
  gtmTracker.pushPageView(location);
  clarityTracker.trackEvent('page_viewed', {});

  const user = getUser();
  if (!user) return;

  setTimeout(() => {
    dbTracker.send('page_viewed', {});
  }, 200);
};

export const resetSession = (): void => {
  dbTracker.reset();
  clarityTracker.reset();
};

export const setTag = (key: string, value: string): void => {
  clarityTracker.setTag(key, value);
};

export const upgradeSession = (reason: string): void => {
  clarityTracker.upgrade(reason);
};



// WEBPACK FOOTER //
// ./src/lib/tracking/index.js